import React from 'react';
import { 
  Row, 
  Col, 
  Card, 
  Typography, 
  Space, 
  Timeline,
  Button
} from 'antd';
import {
  HeartOutlined,
  SecurityScanOutlined,
  TeamOutlined,
  BulbOutlined,
  ClockCircleOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';
import fredrik from "../fredrik.jpeg";
import krister from "../krister.jpeg";
import people from "../people1.jpg";

const { Title, Paragraph, Text } = Typography;

const About = () => {
  const values = [
    {
      icon: <SecurityScanOutlined />,
      title: "Personvern og sikkerhet",
      description: "Vi prioriterer høyeste standard for datasikkerhet og personvern, i tråd med GDPR og norske retningslinjer.",
      bgColor: "#E8F0F5"
    },
    {
      icon: <HeartOutlined />,
      title: "Menneskefokusert design",
      description: "Våre løsninger er designet med brukervennlighet i fokus, for å støtte psykologers viktige arbeid.",
      bgColor: "#EAF4F4"
    },
    {
      icon: <BulbOutlined />,
      title: "Kontinuerlig innovasjon",
      description: "Vi utvikler cutting-edge AI-teknologi som holder tritt med de nyeste fremskrittene innen kunstig intelligens.",
      bgColor: "#FDF3E7"
    },
    {
      icon: <TeamOutlined />,
      title: "Samarbeid og støtte",
      description: "Vi jobber tett med våre brukere for å forstå deres behov og levere løsninger som virkelig gjør en forskjell.",
      bgColor: "#E8EAF6"
    }
  ];

  const teamMembers = [
    {
      name: "Krister Koen",
      role: "Medgründer",
      description: "Krister har jobbet med å utvikle digitale produkter i over 10 år, og brenner for å lage nye produkter og skape gode brukerreiser.",
      image: krister,
    },
    {
      name: "Fredrik Lian",
      role: "Medgründer", 
      description: "Autorisert psykolog med spesialkompetanse innen voksenpsykologi og lang erfaring med psykodynamisk terapi.",
      image: fredrik
    }
  ];

  const milestones = [
    {
      year: "2024",
      title: "Kipler grunnlagt",
      description: "Startet med visjonen om å revolusjonere psykologisk dokumentasjon og gjøre hverdagen enklere for behandlere"
    },
    {
      year: "Q1 2025", 
      title: "Beta-lansering",
      description: "Første versjon av Kipler ble testet internt og teknologien ble raffinert basert på tidlige tilbakemeldinger"
    },
    {
      year: "Q2 2025",
      title: "Pilotprosjekter",
      description: "Samarbeid med utvalgte psykologer for å teste løsningen i reelle behandlingssettinger"
    },
    {
      year: "Q3 2025",
      title: "Offisiell lansering",
      description: "Planlagt lansering for alle psykologer og terapeuter i Norge"
    },
    {
      year: "2026",
      title: "Produktutvidelse",
      description: "Kontinuerlig utvikling av nye funksjoner og forbedringer basert på brukerforslag og behov"
    }
  ];

  return (
    <div style={{ 
      background: 'white',
      minHeight: '100vh'
    }}>
      {/* Hero Section */}
      <div style={{
        background: 'white',
        color: '#230518',
        padding: '100px 50px 20px  50px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
         }}></div>
        
        <div style={{ position: 'relative', zIndex: 1, maxWidth: '800px', margin: '0 auto' }}>
          <Paragraph
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              color: "#f26549",
              textTransform: "uppercase",
              marginBottom: 10,
            }}
          >
            MØTT TEAMET BAK KIPLER
          </Paragraph>
          <Title className='custom-heading' level={1} style={{ 
            color: '#230518', 
            fontSize: '3.5rem', 
            fontWeight: 700,
            marginBottom: '20px',
            marginTop: '5px'
          }}>
            Om oss
          </Title>
          <Paragraph style={{ 
            fontSize: '1.2rem', 
            color: '#333',
            marginBottom: 0
          }}>
            Vi bygger fremtidens verktøy for psykologer - hvor AI møter menneskelig omsorg
          </Paragraph>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ padding: '80px 50px', maxWidth: '1200px', margin: '0 auto' }}>
        
        {/* Mission Section */}
        <Row gutter={[60, 60]} align="middle" style={{ marginBottom: '100px' }}>
          <Col xs={24} lg={12}>
            <Space direction="vertical" size="large">
              <Title level={2} style={{ color: '#230518', marginBottom: '20px' }}>
                  Revolusjonere psykologisk praksis
                </Title>
              <div style={{
                backgroundColor: "#fffaf8",
                padding: "20px",
                borderRadius: "8px"
              }}>
                
                <Paragraph style={{ 
                  fontSize: '1.2rem', 
              
                  lineHeight: '1.8', 
                  color: '#555'
                }}>
                  Vi er et dedikert team med lidenskap for teknologi og helse. Vår visjon 
                  er å bygge innovative løsninger som hjelper psykologer og terapeuter i 
                  deres arbeid. Gjennom avansert AI og sikker teknologi gjør vi 
                  arbeidsdagen enklere, samtidig som vi opprettholder høyeste standard 
                  for personvern og trygghet.
                </Paragraph>
                <Paragraph style={{ fontSize: '1.2rem', lineHeight: '1.8', color: '#555' }}>
                  Vårt mål er å skape verktøy som sparer tid og forbedrer behandlingens 
                  kvalitet. Med et menneskefokusert design og kontinuerlig utvikling 
                  sikrer vi at våre produkter dekker dine behov som profesjonell behandler.
                </Paragraph>
              </div>
            </Space>
          </Col>
          <Col xs={24} lg={12}>
            <div style={{ textAlign: 'center', position: 'relative' }}>
              {/* Main team image with shadow box effect */}
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img 
                  src={people}
                  alt="Kipler team"
                  style={{
                    width: '100%',
                    maxWidth: '500px',
                    borderRadius: '20px',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
                    transform: 'rotate(2deg)',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    zIndex: 2
                  }}
                  onMouseEnter={(e) => e.target.style.transform = 'rotate(0deg) scale(1.05)'}
                  onMouseLeave={(e) => e.target.style.transform = 'rotate(2deg) scale(1)'}
                />
                
              </div>
            </div>
          </Col>
        </Row>

        {/* Statistics */}
        <Card style={{ 
          marginBottom: '80px',
          background: '#230518',
          border: 'none',
          borderRadius: '20px',
          color: 'white'
        }}>
          <Row gutter={[40, 40]} style={{ textAlign: 'center' }} align="middle">
            <Col xs={24} sm={12} md={6}>
              <div>
                <div style={{ color: 'white', fontWeight: 'bold', fontSize: '2.2rem', marginBottom: '8px' }}>
                  2024
                </div>
                <Paragraph style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', margin: 0 }}>
                  Kipler ble etablert med visjon om å revolusjonere psykologisk praksis
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <div>
                <div style={{ color: 'white', fontWeight: 'bold', fontSize: '2.2rem', marginBottom: '8px' }}>
                  3 sek
                </div>
                <Paragraph style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', margin: 0 }}>
                  Fra samtale til ferdig strukturert journalnotat
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <div>
                <div style={{ color: 'white', fontWeight: 'bold', fontSize: '2.2rem', marginBottom: '8px' }}>
                  5+
                </div>
                <Paragraph style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', margin: 0 }}>
                  Terapiretninger støttet: CBT, Psykodynamisk, ACT, ISTDP, EFT og flere
                </Paragraph>
              </div>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <div>
                <div style={{ color: 'white', fontWeight: 'bold', fontSize: '2.2rem', marginBottom: '8px' }}>
                  10x
                </div>
                <Paragraph style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.9rem', margin: 0 }}>
                  Dypere innsikt med analyser som gir omfattende forståelse av terapeutiske mønstre
                </Paragraph>
              </div>
            </Col>
          </Row>
        </Card>

        {/* Values Section */}
        <div style={{ marginBottom: '100px' }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '60px', color: '#230518' }}>
            Våre verdier
          </Title>
          <Row gutter={[30, 30]}>
            {values.map((value, index) => (
              <Col xs={24} sm={12} lg={6} key={index}>
                <Card
                  style={{
                    height: '100%',
                    textAlign: 'center',
                    border: 'none',
                    borderRadius: '15px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                    transition: 'all 0.3s ease',
                  }}
                  
                  bodyStyle={{ padding: '40px 20px' }}
                >
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: value.bgColor,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    fontSize: '2rem',
                    color: '#230518',
                  }}>
                    {value.icon}
                  </div>
                  <Title level={4} style={{ marginBottom: '15px', color: '#230518' }}>
                    {value.title}
                  </Title>
                  <Paragraph style={{ color: '#17403E', margin: 0, fontSize: "1.2rem", fontWeight: "300" }}>
                    {value.description}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Team Section */}
        <div style={{ 
          background: '#fffaf8',
          borderRadius: '30px',
          paddingTop: '50px',
          paddingBottom: '50px',
          paddingLeft: '10px',
          paddingRight: '10px',
          color: '#230518',
          marginBottom: '80px'
        }}>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '60px', color: '#230518' }}>
            Møt grunnleggerne
          </Title>
          <Row gutter={[40, 40]} justify="center">
            {teamMembers.map((member, index) => (
              <Col xs={24} md={12} lg={10} key={index}>
                <Card
                  style={{
                    background: 'white',
                    border: '1px solid rgba(0,0,0,0.1)',
                    borderRadius: '20px',
                    textAlign: 'center',
                    color: '#230518',
                    height: '100%',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                  }}
                  bodyStyle={{ padding: '40px 20px' }}
                >
                  <img 
                    src={member.image}
                    alt={member.name}
                    style={{ 
                      width: '150px',
                      height: '150px',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      transition: 'all 0.3s ease',

                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'rotate(0deg) scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'rotate(-5deg) scale(1)'}
                  />
                  <Title level={4} style={{ color: '#230518', marginBottom: '5px' }}>
                    {member.name}
                  </Title>
                  <Text style={{ color: '#f26549', fontSize: '1.1rem', fontWeight: '500' }}>
                    {member.role}
                  </Text>
                  <Paragraph style={{ color: '#333', marginTop: '15px', margin: 0, fontSize: '1rem' }}>
                    {member.description}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>
        </div>

        {/* Timeline Section */}
        <div>
          <Title level={2} style={{ textAlign: 'center', marginBottom: '60px', color: '#230518' }}>
            Vår reise
          </Title>
          <Card style={{ 
            border: 'none',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
          }}>
            <Timeline
              mode="alternate"
              items={milestones.map((milestone, index) => ({
                dot: <ClockCircleOutlined style={{ fontSize: '16px', color: '#f26549' }} />,
                children: (
                  <div>
                    <Title level={4} style={{ color: '#f26549', margin: '0 0 10px 0' }}>
                      {milestone.year}
                    </Title>
                    <Title level={5} style={{ margin: '0 0 5px 0', color: '#230518', }}>
                      {milestone.title}
                    </Title>
                    <Paragraph style={{ color: '#333', margin: 0, fontSize: '1rem' }}>
                      {milestone.description}
                    </Paragraph>
                  </div>
                )
              }))}
            />
          </Card>
        </div>

        {/* Call to Action */}
        <div style={{ textAlign: 'center', marginTop: '80px' }}>
          <Title level={3} style={{ color: '#230518', marginBottom: '20px' }}>
            Klar til å prøve Kipler?
          </Title>
          <Paragraph style={{ fontSize: '1.2rem', color: '#333', marginBottom: '30px' }}>
            Bli med oss på reisen mot mer effektiv psykologisk praksis
          </Paragraph>
          <a href="https://app.kipler.ai" target="_blank" rel="noopener noreferrer">
            <Button 
              type="primary" 
              size="large" 
              style={{ 
                backgroundColor: "#f26549", 
                fontWeight: 600,
                borderColor: "#f26549",
                padding: "12px 30px",
                height: "auto"
              }}
            >
              Prøv gratis nå <ArrowRightOutlined />
            </Button>
          </a>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>
    </div>
  );
};

export default About;